
<template>
    <!-- 案例详情 -->
    <div class="case-detail">
        <div class="case-pre" v-for="item in detail">
            <template v-if="item.type === 'image'">
                <img :src="require(`@/assets/img/${item.content}`)" alt="">
                <div v-if="item.desc" class="desc">{{ item.desc }}</div>
            </template>
            <template v-else>
                <div style="white-space:pre-line; text-align: left;">
                    {{ item.content }}
                </div>
            </template>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'Contact',
    props: {
    },
    computed: {
        list() {
            return this.$t('case.list');
        },
        detail() {
            const { params: { id } } = this.$route;
            const currentDetail = this.list.filter(({ key }) => key === id)[0] || {};
            return currentDetail.detail || [];
        }
    },
}
</script>
  
<style scoped>
.case-detail {
    text-align: center;
}

.case-pre {
    margin-top: 40px;
    line-height: 30px;
}
</style>
  